import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import packageJson from '../../../../../package.json';
import { Router } from '@angular/router';



@Component({
    selector: 'app-modal-cookies',
    templateUrl: './modal-cookies.component.html',
    standalone: false
})
export class ModalCookiesComponent {

  version: string = packageJson.version;

    policyUrl: string;

  constructor(private activeModal: NgbActiveModal, private _translate: TranslateService, private router: Router){
}

  aceptar() {
    localStorage.setItem("cookies",  'true'+ ` ${this.version}`);
    this.activeModal.close();

  }

  rechazar() {
    this.activeModal.close();
  }

}
